/* global google */
import React from 'react';
import { Marker } from 'react-google-maps';

import markerSvg from './markerSvg';

const EventMarker = ({ event, ...props }) => (
  <Marker
    {...props}
    position={{
      lat: event.geoPoint.latitude,
      lng: event.geoPoint.longitude
    }}
    icon={{
      ...markerSvg,
      fillColor: event.crew ? (event.crew.equipment ? event.crew.equipment.color : '#3F6627') : '#B2B2B2'
    }}
    defaultAnimation={2}
  />
);

export default EventMarker;
